"use strict";
exports.__esModule = true;
exports.celoKit = void 0;
var contractkit_1 = require("@celo/contractkit");
var env_1 = require("../../../env");
var kit;
var celoKit = function () {
    if (!kit)
        kit = (0, contractkit_1.newKit)((0, env_1.getEnv)("API_CELO_NODE"));
    return kit;
};
exports.celoKit = celoKit;
//# sourceMappingURL=sdk.js.map